import React from 'react'

function FarmshopNotification( {notificationText} ) {
  return (
    <div className="response" id="mce-success-response">{notificationText}</div>
  )
}

export default FarmshopNotification
